import { render, staticRenderFns } from "./op_up_push.vue?vue&type=template&id=219e1540&scoped=true"
import script from "./op_up_push.vue?vue&type=script&lang=js"
export * from "./op_up_push.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e1540",
  null
  
)

export default component.exports